import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './ArchiveItemDialog.module.css'
import { byDesign } from '@/infra/design'
import imgArchiveItemUrl from '@/assets/misc/img_archive-item.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface ArchiveItemDialogProps {
  showing: boolean
  onClose: () => unknown
  onArchive: () => unknown
  isArchivePending: boolean
  isOverride?: boolean
  inventoryItemName?: string
  workspaceName?: string
  corporateMode: boolean
  testId?: string
}

export function ArchiveItemDialog({
  showing,
  onClose,
  onArchive,
  isArchivePending,
  isOverride,
  inventoryItemName,
  workspaceName,
  corporateMode,
  testId,
}: ArchiveItemDialogProps) {
  const inventoryItemNameLength = inventoryItemName?.length ?? 0
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isArchivePending ? undefined : onClose}
    >
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton
            testId={testId ? `${testId}-close-archive-modal` : undefined}
          />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgArchiveItemUrl}
              illustration={byDesign(undefined, DocumentsDisabledIllustration)}
              alt="Archive item"
            />
          )}
          <h3 className={styles.title}>
            {isOverride ? (
              <>
                You are about to archive this override of{' '}
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            ) : (
              <>
                You are about to archive{' '}
                {inventoryItemNameLength < 44 ? (
                  <span className={styles.inventoryItemName}>
                    {inventoryItemName}
                  </span>
                ) : (
                  inventoryItemName
                )}
              </>
            )}
          </h3>
          <p className={styles.description}>
            {isOverride ? (
              'All legends in ' +
              (workspaceName ?? 'this workspace') +
              ' will need to be updated to reference the global version of this item.'
            ) : (
              <>
                All legends will no longer be able to reference this service
                item. All existing legends that used this item, will need manual
                adjustments.
              </>
            )}
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            isDisabled={isArchivePending}
            onPress={onClose}
            variant="default"
          />
          <Button
            label="Archive"
            onPress={onArchive}
            isPending={isArchivePending}
            isDisabled={isArchivePending}
            variant="destructive"
            testId={testId ? `${testId}-archive-button` : undefined}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
